import {ThemedStyleSheet} from '../../Utils/ThemedStyleSheet';
import {Spacing} from '../../Styles';

const TRAINING_BLUE = '#2E75B6';
const TRAINING_BLUE_LIGHT = '#E7F3FC';
const TRAINING_BLUE_SOFT = '#F3F8FC';
const TRAINING_BLUE_BORDER = '#6CB7EA';

export default ThemedStyleSheet((theme) => ({
  scrollContent: {
    paddingTop: Spacing.small,
    paddingBottom: Spacing.large,
  },
  titleBand: {
    minHeight: 82,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#DDEFFB',
    borderRadius: 8,
    marginBottom: Spacing.small,
    paddingHorizontal: Spacing.small,
    paddingVertical: Spacing.small,
  },
  titleIconContainer: {
    width: 44,
    height: 44,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.surface,
    marginRight: Spacing.small,
  },
  titleIcon: {
    color: TRAINING_BLUE,
  },
  titleText: {
    flex: 1,
  },
  title: {
    color: TRAINING_BLUE,
  },
  titleSubtitle: {
    color: '#55768F',
    lineHeight: 20,
    marginTop: Spacing.xxsmall,
  },
  guidanceBadge: {
    alignSelf: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#B9D7EC',
    borderRadius: 8,
    backgroundColor: '#F8FCFF',
    paddingHorizontal: Spacing.small,
    paddingVertical: Spacing.xsmall,
    marginBottom: Spacing.small,
  },
  guidanceIcon: {
    color: TRAINING_BLUE,
    marginRight: Spacing.xsmall,
  },
  guidanceBadgeText: {
    color: TRAINING_BLUE,
    fontSize: 12,
    lineHeight: 17,
  },
  introPanel: {
    backgroundColor: TRAINING_BLUE_SOFT,
    borderWidth: 1,
    borderColor: '#CFE2F1',
    borderRadius: 8,
    padding: Spacing.small,
    marginBottom: Spacing.medium,
  },
  introText: {
    color: theme.colors.textLight,
    lineHeight: 22,
  },
  sectionLabel: {
    color: theme.colors.textStrong,
    fontSize: 14,
    lineHeight: 20,
    marginBottom: Spacing.xsmall,
  },
  moduleButton: {
    minHeight: 76,
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#A9D2ED',
    borderRadius: 8,
    backgroundColor: '#F5FBFF',
    paddingHorizontal: Spacing.small,
    paddingVertical: Spacing.small,
    marginBottom: Spacing.xsmall,
  },
  moduleButtonExpanded: {
    backgroundColor: TRAINING_BLUE_LIGHT,
    borderColor: TRAINING_BLUE,
    borderWidth: 2,
  },
  moduleButtonPressed: {
    opacity: 0.78,
  },
  moduleText: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  moduleNumber: {
    width: 36,
    height: 36,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#DDEFFB',
    marginRight: Spacing.small,
  },
  moduleNumberText: {
    color: TRAINING_BLUE,
  },
  moduleLabel: {
    flex: 1,
  },
  moduleTitle: {
    color: TRAINING_BLUE,
  },
  moduleSubtitle: {
    color: '#55768F',
    marginTop: Spacing.xxsmall,
  },
  chevron: {
    color: TRAINING_BLUE_BORDER,
    marginLeft: Spacing.xsmall,
  },
  moduleDetail: {
    backgroundColor: theme.colors.surface,
    borderWidth: 1,
    borderColor: '#CFE2F1',
    borderRadius: 8,
    padding: Spacing.small,
    marginTop: -Spacing.xxsmall,
    marginBottom: Spacing.small,
  },
  detailOverview: {
    color: theme.colors.textLight,
    lineHeight: 22,
  },
  detailHeading: {
    color: theme.colors.textStrong,
    marginTop: Spacing.small,
    lineHeight: 22,
  },
  detailItem: {
    color: theme.colors.textLight,
    lineHeight: 22,
    marginTop: Spacing.xsmall,
  },
  futureModule: {
    minHeight: 76,
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderStyle: 'dashed',
    borderColor: theme.colors.border,
    borderRadius: 8,
    backgroundColor: theme.colors.surfaceSecondary,
    paddingHorizontal: Spacing.small,
    paddingVertical: Spacing.xsmall,
  },
  futureModuleTitle: {
    color: '#9889CF',
  },
  futureModuleSubtitle: {
    color: '#B4A9DA',
    marginTop: Spacing.xxsmall,
  },
  futureModuleNumber: {
    width: 36,
    height: 36,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#EEE9FA',
    marginRight: Spacing.small,
  },
  futureModuleNumberIcon: {
    color: '#9889CF',
  },
  futureModuleIcon: {
    color: '#B4A9DA',
    marginLeft: Spacing.xsmall,
  },
}));
